/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const overallSchema = z.object({
  passed: z.number(),
  failed: z.number(),
  skipped: z.number(),
  expired: z.number(),
  totalTimeSpent: z.number(),
  totalReviews: z.number(),
  totalSessions: z.number(),
});

export type IOverall = z.infer<typeof overallSchema>;
